import { render } from "./mnStatusIndicator.vue?vue&type=template&id=e4b4f4c6&scoped=true"
import script from "./mnStatusIndicator.vue?vue&type=script&lang=js"
export * from "./mnStatusIndicator.vue?vue&type=script&lang=js"

import "./mnStatusIndicator.vue?vue&type=style&index=0&id=e4b4f4c6&scoped=true&lang=css"

import exportComponent from "D:\\php\\php20260824_dianshang\\mall-son_dxt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4b4f4c6"]])

export default __exports__